import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'values',
    standalone: false
})
export class ValuesPipe implements PipeTransform {

  transform(array: any): any {
    return Object.values(array);
  }

}
